import { Component } from '@theme/component';

/** @extends {Component<{tabs: HTMLButtonElement[], panels: HTMLDivElement[]}>} */
class MitoqHomeExperts extends Component {
  /** @param {MouseEvent} event */
  selectTab(event) {
    const button = event.target instanceof Element ? event.target.closest('[role="tab"]') : null;
    if (!(button instanceof HTMLButtonElement) || !this.refs.tabs?.includes(button)) return;
    this.activate(Number(button.dataset.index));
  }

  /** @param {KeyboardEvent} event */
  handleKeydown(event) {
    const tabs = this.refs.tabs ?? [];
    const current = tabs.indexOf(event.target);
    if (current < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const rtl = getComputedStyle(this).direction === 'rtl';
    let next = current;
    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else next = (current + ((event.key === 'ArrowRight') !== rtl ? 1 : -1) + tabs.length) % tabs.length;
    this.activate(next);
    tabs[next]?.focus({ preventScroll: true });
  }

  /** @param {number} index */
  activate(index) {
    const tabs = this.refs.tabs ?? [];
    const panels = this.refs.panels ?? [];
    if (!Number.isInteger(index) || index < 0 || index >= tabs.length || !panels[index]) return;
    for (const [i, tab] of tabs.entries()) {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      if (panels[i]) panels[i].hidden = i !== index;
    }
    const list = tabs[index].closest('[role="tablist"]');
    if (list) {
      const box = tabs[index].getBoundingClientRect();
      const bounds = list.getBoundingClientRect();
      if (box.left < bounds.left) list.scrollBy({ left: box.left - bounds.left, behavior: 'instant' });
      else if (box.right > bounds.right) list.scrollBy({ left: box.right - bounds.right, behavior: 'instant' });
    }
  }
}

if (!customElements.get('mitoq-home-experts')) customElements.define('mitoq-home-experts', MitoqHomeExperts);
